export default __webpack_public_path__ + "static/media/img-clipart-wwd-money.2b0174d9.png";